import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { useGetDomainsCategoriesQuery, useLazyGetDomainsCategoriesQuery } from '../../redux/apis/domainsManagement/category/dMDomainsCategoryApiSlice'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import EditCreateDomainCategoriesModal from '../../components/domains/EditCreateDomainCategories'
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar'
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton'
import { can } from '../../helpers/auth'

const DomainsCategories = React.memo(() => {
  const context = useContext(AppSettings)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 })
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})
  const { data, isLoading, error, isFetching } = useGetDomainsCategoriesQuery({
    expand: ['last_updated_by'].join(','),
    page: pagination.current,
    page_size: pagination.pageSize,
    ...(search ? { search } : {}),
    ...filters
  })
  const [open, setOpen] = useState(false)
  const [holder, setHolder] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'DOMAIN CATEGORY',
      dataIndex: 'domain_category',
      key: 'domain_category',
      filter: true,
      filterType: 'text'
    },
    {
      title: 'CATEGORY STATUS',
      dataIndex: 'category_status',
      key: 'category_status',
      filter: true,
      filterType: 'select',
      filterOptions: [
        { label: 'Active', value: true },
        { label: 'Inactive', value: false }
      ],
      render: text => <p>{text ? 'active' : 'inActive'}</p>
    },
    {
      title: 'LAST UPDATED BY',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: text => (
        <p>
          {text?.first_name} {text?.last_name}
        </p>
      )
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          {can('change_domaincategory') && (
            <button
              className='btn btn-outline-theme'
              onClick={() => handelEdit(record)}
            >
              Edit
            </button>
          )}
        </div>
      )
    }
  ]

  const handelEdit = record => {
    setOpen(true)
    setHolder(record)
    setIsEdit(true)
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div>
      <Loader isLoading={isLoading || isFetching} />

      <div className='flex'>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />
        <div className='ml-auto flex gap-4'>
          <DownloadAllDataButton
            lazyQueryHook={useLazyGetDomainsCategoriesQuery}
            fileName='domains-category'
          />
          {(can('add_domaincategory') || can('change_domaincategory')) && (
            <EditCreateDomainCategoriesModal
              open={open}
              setOpen={setOpen}
              category={holder}
              isEdit={isEdit}
              setHolder={setHolder}
              setIsEdit={setIsEdit}
            />
          )}
        </div>
      </div>
      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default DomainsCategories
